import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// biome-ignore lint/style/useNamingConvention: must be that way
export const DOMAIN_NUMBER_STR: DiToken<string> = new DiToken<string>('domainNumberStr', {
  factory: () => ''
});
